<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Mails" class="d-icon d-icon--mails" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 12"><path fill="currentColor" fill-rule="evenodd" d="M4.5 2.5A.5.5 0 0 0 4 3v.2l3.283 1.748a.458.458 0 0 0 .433 0L11 3.2V3a.5.5 0 0 0-.5-.5h-6Zm7.5.99V3a1.5 1.5 0 0 0-1.5-1.5h-6A1.5 1.5 0 0 0 3 3v4.5A1.5 1.5 0 0 0 4.5 9h6A1.5 1.5 0 0 0 12 7.5V3.49Zm-1 .843-2.817 1.5a1.46 1.46 0 0 1-1.366 0l-.002-.002L4 4.333V7.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V4.333ZM1.5 3.5A.5.5 0 0 1 2 4v5.5c0 .274.226.5.5.5h7a.5.5 0 0 1 0 1h-7C1.674 11 1 10.326 1 9.5V4a.5.5 0 0 1 .5-.5Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconMails',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
